import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HandoverChain, HandOffRequest } from '../models/handover-chain.model';

@Injectable({ providedIn: 'root' })
export class TestModuleHandoverService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  private url(projectId: string, moduleId: string): string {
    return `${this.base}/${projectId}/test-modules/${moduleId}/handovers`;
  }

  list(projectId: string, moduleId: string): Observable<HandoverChain> {
    return this.http.get<HandoverChain>(this.url(projectId, moduleId));
  }

  handOff(projectId: string, moduleId: string, request: HandOffRequest): Observable<HandoverChain> {
    return this.http.post<HandoverChain>(this.url(projectId, moduleId), request);
  }

  skip(projectId: string, moduleId: string, handoverId: string): Observable<HandoverChain> {
    return this.http.patch<HandoverChain>(`${this.url(projectId, moduleId)}/${handoverId}/skip`, {});
  }

  close(projectId: string, moduleId: string): Observable<HandoverChain> {
    return this.http.patch<HandoverChain>(`${this.url(projectId, moduleId)}/close`, {});
  }

  reopen(projectId: string, moduleId: string): Observable<HandoverChain> {
    return this.http.patch<HandoverChain>(`${this.url(projectId, moduleId)}/reopen`, {});
  }
}
